import api from '@/lib/api'

const state = () => ({
  trades: [],
})

const getters = {
  trades: state => state.trades,
}

const actions = { 
  async loadTrades({ commit }) {
    const result = await api.get('/trades')
    if (result.ok) {
      commit('SET_TRADES', await result.json())
      return { ok: true }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_TRADES: (state, trades) => state.trades = trades.sort( (a,b) => a.name.localeCompare(b.name))
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}